import styled from "styled-components"

export const StyledHeaderWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  @media only screen and (max-width: 767px) {
    width: 100%;
  }
`
